import { UrlService } from '../../../@core/services/urlService/url.service';
import { CategoriaPreguntasFrecuentesData, CategoriaPreguntasFrecuentes } from '../models/categoria-preguntas-frequentes';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class CategoriaPreguntasFrecuentesService extends CategoriaPreguntasFrecuentesData {
  private apiRoute: string;

  constructor(private urlService: UrlService, private http: HttpClient) {
    super();
    this.apiRoute = `${this.urlService.getBaseUrl()}CategoriaPreguntasFrecuentes/`;
  }

  create(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.apiRoute}CrearCategoriaPreguntasFrecuentes`, formData);
  }

  update(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.apiRoute}EditarCategoriaPreguntasFrecuentes`, formData);
  }

  getList(): Observable<CategoriaPreguntasFrecuentes[]> {
    return this.http.get<CategoriaPreguntasFrecuentes[]>(`${this.apiRoute}GetCategoriaPreguntasFrecuentes/`);
  }

  getById(id: number): Observable<CategoriaPreguntasFrecuentes> {
    return this.http.get<CategoriaPreguntasFrecuentes>(`${this.apiRoute}GetCategoriaPreguntasFrecuentesById/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.post<any>(`${this.apiRoute}EliminarCategoriaPreguntasFrecuentes/${id}`, {});
  }
}
